import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import './App.css';
import NavBar from "./CommonComponents/NavBar";
import { AuthProvider } from './contexts/AuthContext';
import AdminRouter from "./pages/admin/admin";
import Public from "./pages/public/Public";
import AdminRoute from './routes/AdminRoute';
import { Container } from "react-bootstrap";
function App() {
  return (

    <Container fluid className='100vh m-0 p-0'>
      <Router>
        <AuthProvider>
          <NavBar />
          <Switch>

            <AdminRoute path='/admin' component={AdminRouter} />

            <Route path='/' component={Public} />

          </Switch>
        </AuthProvider>
      </Router>
    </Container>

  )
}


export default App;
